import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Settings parent route — Outlet layout per [[tanstack-route-layout-pattern]].
 * Index landing lives in `settings.index.tsx`; sub-pages (eBay integration,
 * listing templates, bundle defaults, etc.) live as siblings and slot into
 * this Outlet so we don't end up rendering settings.index.tsx as the
 * parent fallback when the child fails to register.
 */
export const Route = createFileRoute("/settings")({
  component: SettingsLayout,
});

function SettingsLayout() {
  return <Outlet />;
}
